import { render } from "./AddProjectManagerModal.vue?vue&type=template&id=ea48aa74&scoped=true"
import script from "./AddProjectManagerModal.vue?vue&type=script&lang=js"
export * from "./AddProjectManagerModal.vue?vue&type=script&lang=js"

import "./AddProjectManagerModal.vue?vue&type=style&index=0&id=ea48aa74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea48aa74"]])

export default __exports__